import {Injectable} from "@angular/core";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { environment } from '../../../environments/environment';

import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class PessoaFiltroService {

  private _Url = environment.UrlPrincipal + '/api/pessoafiltro';

  constructor(private http: HttpClient) {}

  list(codigo_pessoa, slug_pagina = null) {
    return this.http.get(this._Url + '/' + codigo_pessoa + '?slug_pagina=' + slug_pagina)
            .catch(this.handleError);
  }

  find(codigo) {
    return this.http.get(this._Url + '/' + codigo)
            .catch(this.handleError);
  }

  private handleError(error: Response) {
    return error.json();
  }

}
